<ng-container *ngIf="!initializerService.duplicateTab">
  <finfra-progress-spinner-component></finfra-progress-spinner-component>
  <router-outlet></router-outlet>
</ng-container>
<ng-container *ngIf="initializerService.duplicateTab">
  <div class="center-page">
    <h2 class="center-page-content">This is a duplicate tab. {{configService.getConfig('global').productName}} is already open in another tab!</h2>
  </div>
</ng-container>
